// extracted by mini-css-extract-plugin
export default {"whoWeAre":"WhoWeAre_whoWeAre__dg1o9","content":"WhoWeAre_content__HH9Dn","btn":"WhoWeAre_btn__-qXd+","imageWrapper":"WhoWeAre_imageWrapper__q7b-d"};